import React from 'react';
import { Link } from 'react-scroll';
import MobileMenu from '../MobileMenu/MobileMenu';
import { useLanguage } from '../../i18n/LanguageContext';

const Header = (props) => {
  const { t, language, setLanguage } = useLanguage();

  const langSwitchStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '20px',
    padding: '4px',
    marginRight: '12px',
  };

  const langBtnStyle = (active) => ({
    background: active ? '#06b6d4' : 'transparent',
    color: active ? '#0d1117' : 'rgba(255,255,255,0.5)',
    border: 'none',
    borderRadius: '12px',
    padding: '3px 9px',
    fontWeight: active ? 700 : 500,
    cursor: 'pointer',
    fontSize: '12px',
    lineHeight: 1,
    transition: 'all 0.2s',
  });

  return (
    <header id="header" className={`wpo-header-style-1 ${props.hClass || ''}`}>
      <div className="wpo-site-header">
        <nav className="navigation navbar navbar-expand-lg">
          <div className="container">
            <div className="row align-items-center" style={{ width: '100%' }}>
              <div className="col-lg-3 col-md-3 col-2 d-lg-none dl-block">
                <MobileMenu />
              </div>
              <div className="col-lg-2 col-md-6 col-2">
                <div className="navbar-header">
                  <Link
                    className="navbar-brand"
                    to="home"
                    spy smooth duration={500}
                    style={{ color: '#06b6d4', fontWeight: 800, fontSize: '18px', letterSpacing: '1px', textDecoration: 'none' }}
                  >
                    EM
                  </Link>
                </div>
              </div>
              <div className="col-lg-7 d-none d-lg-block">
                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li>
                      <Link activeClass="active" to="service" spy smooth duration={500}>
                        {t.nav.services}
                      </Link>
                    </li>
                    <li>
                      <Link activeClass="active" to="work" spy smooth duration={500}>
                        {t.nav.work}
                      </Link>
                    </li>
                    <li>
                      <Link activeClass="active" to="results" spy smooth duration={500}>
                        {t.nav.results}
                      </Link>
                    </li>
                    <li>
                      <Link activeClass="active" to="contact" spy smooth duration={500}>
                        {t.nav.contact}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-8">
                <div className="header-right" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <div className="header-language-switch" style={langSwitchStyle}>
                    <button style={langBtnStyle(language === 'en')} onClick={() => setLanguage('en')}>EN</button>
                    <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '12px' }}>|</span>
                    <button style={langBtnStyle(language === 'es')} onClick={() => setLanguage('es')}>ES</button>
                  </div>
                  <Link
                    to="contact"
                    spy smooth duration={500}
                    className="theme-btn header-cta-btn"
                    style={{ fontSize: '13px', padding: '10px 20px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                  >
                    <span className="header-cta-label">{t.hero.cta}</span>
                    <span className="header-cta-short">Agenda</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
